import { render, staticRenderFns } from "./ForwardEmail.vue?vue&type=template&id=315a323a&scoped=true&"
import script from "./ForwardEmail.vue?vue&type=script&lang=js&"
export * from "./ForwardEmail.vue?vue&type=script&lang=js&"
import style0 from "./ForwardEmail.vue?vue&type=style&index=0&id=315a323a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315a323a",
  null
  
)

export default component.exports